import {Modal, Radio, Space} from "antd";
import React, {useState} from "react";
import FilterButton from "../../piece/FilterButton";
import {GroupOutlined} from "@ant-design/icons";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [minSizeWFilter, setMinSizeWFilter] = useState(null)
    const [maxSizeWFilter, setMaxSizeWFilter] = useState(null)
    const [minSizeHFilter, setMinSizeHFilter] = useState(null)
    const [maxSizeHFilter, setMaxSizeHFilter] = useState(null)

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <GroupOutlined/> Size Range
            </FilterButton>
            <Modal
                title='Size Filter'
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            minSizeWFilter: {
                                text: 'Min Width(in)',
                                value: minSizeWFilter
                            },
                            maxSizeWFilter: {
                                text: 'Max Width(in)',
                                value: maxSizeWFilter
                            },
                            minSizeHFilter: {
                                text: 'Min height(in)',
                                value: minSizeHFilter
                            },
                            maxSizeHFilter: {
                                text: 'Max height(in)',
                                value: maxSizeHFilter
                            }
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
            >
                <Radio.Group
                    onChange={(e) => {
                        switch (e.target.value) {
                            case 1:
                                setMinSizeWFilter(1)
                                setMaxSizeWFilter(15)
                                setMinSizeHFilter(1)
                                setMaxSizeHFilter(15)
                                break
                            case 2:
                                setMinSizeWFilter(15)
                                setMaxSizeWFilter(40)
                                setMinSizeHFilter(15)
                                setMaxSizeHFilter(40)
                                break
                            case 3:
                                setMinSizeWFilter(40)
                                setMaxSizeWFilter(10000000)
                                setMinSizeHFilter(40)
                                setMaxSizeHFilter(10000000)
                                break
                        }
                    }}
                >
                    <Space direction='vertical'>
                        <Radio value={1}>small (≤ 15" x 15")</Radio>
                        <Radio value={2}>medium (15" x 15" - 40" x 40")</Radio>
                        <Radio value={3}>large (over 40" x 40")</Radio>
                    </Space>
                </Radio.Group>
            </Modal>
        </>
    )
}